import { BaseGenerator } from '../core/BaseGenerator.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Argentine CUIL generator following Single Responsibility Principle
 */
export class CuilGenerator extends BaseGenerator {
  generate(options = {}) {
    const { formatted = true, gender = null } = options;

    // Gender prefix: 20/23/24 for male, 27 for female
    let prefix;
    if (gender === 'male') {
      prefix = ['20', '23', '24'][this.randomInt(0, 2)];
    } else if (gender === 'female') {
      prefix = '27';
    } else {
      prefix = ['20', '23', '24', '27'][this.randomInt(0, 3)];
    }

    // Generate 8 digits (DNI)
    const dni = this.randomDigits(8);
    
    // Calculate check digit
    const digits = prefix + dni;
    const checksum = ChecksumCalculator.calculateCuilChecksum(digits);
    
    const cuil = digits + checksum;
    
    return formatted ? 
      `${cuil.substring(0, 2)}-${cuil.substring(2, 10)}-${cuil.substring(10, 11)}` : 
      cuil;
  }
}